export default __webpack_public_path__ + "static/media/spinner-white.80e5f2d0.svg";